module.exports = __webpack_public_path__ + "img/future-news-logo.6d03ebc8.svg";